<div class = "body">

    <div class = "afiliado" *ngIf = "rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

        <div class = "container" style = "height:100px"> </div>

        <div class = "container" id = "tabla" style = "background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class = "row">

                <div class = "col-lg-4"> <h1> Postulaciones </h1> </div>

                <div class = "col-lg-5"> </div>

                <div class = "col-lg-2"> <h3> Cantidad de Registros </h3> </div>

                <div class = "col-lg-1">

                    <select class = "form-control" [(ngModel)] = "config.itemsPerPage">

                        <option value = "5">5</option>
                        <option value = "10">10</option>
                        <option value = "20">20</option>
                        <option value = "30">30</option>
                        <option value = "50">50</option>

                    </select> </div>

            </div> <hr/> <br/>

            <div class = "table-responsive">

                <table class = "table">

                    <thead style = "background-color: #0f69b4;color:white;">

                        <tr>
                            <th> N° </th>
                            <th> Rut </th>
                            <th> Nombre y Apellido </th>
                            <th> Fecha Ingreso </th>
                            <th> Producto </th>
                            <th> Tipo de Producto </th>
                            <th> Estado </th>
                            <th> Motivo Rechazo </th>
                            <th> Ver Archivo </th>
                            <th>  </th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr  [class] = "i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor = "let postulacion of postulaciones | paginate: config; let i = index">

                            <td> {{postulacion.posId}} </td>
                            <td> {{postulacion.rutPostulante}} </td>
                            <td> {{postulacion.nombrePostulante}} </td>
                            <td> {{postulacion.fechaIngreso}} </td>
                            <td> {{postulacion.producto}} </td>
                            <td> {{postulacion.tipoBeca}} </td>
                            <!--<td> {{postulacion.estado}} </td>--> 
                            <td style="text-align: center;" *ngIf="postulacion.estado == 'RECHAZADA'"> <a (click)="detalleRechazoBeneficiario(postulacion.posId)" style="cursor:pointer; text-decoration: underline;">{{postulacion.estado}} </a></td>
                            <td style="text-align: center;" *ngIf="postulacion.estado == 'PAGADA'"> <a (click)="detalleSolicitudPagada(postulacion.posId)" style="cursor:pointer; text-decoration: underline;">{{postulacion.estado}} </a></td>
                            <td style="text-align: center;" *ngIf="postulacion.estado != 'RECHAZADA' && postulacion.estado != 'PAGADA'"> {{postulacion.estado}}</td>

                            <td> {{postulacion.motivoRechazo}} </td>

                            <td> <button class = "btn btn-info" (click) = "verArchivo(postulacion.posId)" style = "width: 120px">

                                <i class = "fa fa-search"> </i> Ver

                            </button> </td>
                        
                            <td> <button *ngIf = "postulacion.estado == 'INGRESADA'"  style = "width: 120px"
                            class = "btn btn-danger" (click) = "openDialog(postulacion.posId, postulacion.nombreProducto)">

                                <i class = "fa fa-trash"> </i> Anular

                            </button> </td>

                        </tr>

                    </tbody>

                </table> <br/>

                <pagination-controls style = "text-align: center" previousLabel = "Anterior" nextLabel = "Siguiente"
                (pageChange) = "pageChanged($event)" autoHide = "true"> </pagination-controls>

            </div>

        </div>

        <div class = "container" style = "height:100px"> </div>

    </div>

    <div class = "afiliado" *ngIf = "rol != 'ROLE_AFILIADO'">

        <div class = "container" style = "height:100px"> </div>

        <div class = "container" id = "tabla" style = "background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class = "row">

                <div class = "col-lg-4"> <h1> Postulaciones {{tipoPostulacion}} </h1> </div>

                <div class = "col-lg-2"> </div>

                <div class = "col-lg-3" *ngIf = "tipoPostulacion == 'Asignadas'">

                    <button class = "btn btn-info" (click) = "postulacionesDisponibles(true)"> Postulaciones Disponibles </button>

                </div>

                <div class = "col-lg-3" *ngIf = "tipoPostulacion == 'Disponibles'">

                    <button class = "btn btn-info" (click) = "postulacionesAsignadas(true)"> Postulaciones Asignadas </button>

                </div>

                <div class = "col-lg-2"> <h3> Cantidad de Registros </h3> </div>

                <div class = "col-lg-1">

                    <select class = "form-control" (change) = "buscar()" [(ngModel)] = "buscador.itemsPerPage">

                        <option value = "5">5</option>
                        <option value = "10">10</option>
                        <option value = "20">20</option>
                        <option value = "30">30</option>
                        <option value = "50">50</option>

                    </select> </div>

            </div> <hr/> <br/>

            <div >

                    <div class = "row">

                    <div class = "col-lg-2"> <h3> RUT de Usuario: </h3> </div>

                    <div class = "col-lg-3">

                        <input name = "rut" class = "form-control" type = "text" #rut = "ngModel"
                        [(ngModel)] = "buscador.rut" placeholder = "Ingrese el RUT (11111111-1)" pattern = "[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>

                    <div class = "col-lg-2" *ngIf = "this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_NACIONAL' || this.rol == 'ROLE_CONTABILIDAD' || this.rol == 'ROLE_COORDINADOR' || this.rol == 'ROLE_ASISTENTE_SOCIAL' "> <h3> Región: </h3> </div>

                    <div class = "col-lg-3" *ngIf = "this.rol == 'ROLE_ADMINISTRADOR' || this.rol == 'ROLE_ENCARGADO_NACIONAL' || this.rol == 'ROLE_CONTABILIDAD' || this.rol == 'ROLE_COORDINADOR' || this.rol == 'ROLE_ASISTENTE_SOCIAL'"> 

                        <mat-select [(ngModel)] = "buscador.region" [disabled] = "this.rol != 'ROLE_ADMINISTRADOR' && this.rol != 'ROLE_ENCARGADO_NACIONAL' && this.rol != 'ROLE_CONTABILIDAD'&& this.rol != 'ROLE_COORDINADOR' && this.rol != 'ROLE_ASISTENTE_SOCIAL'">
                          <mat-option  value = "0">

                              SELECCIONE....

                          </mat-option>
                            <mat-option *ngFor = "let region of regiones" value = "{{region.id}}">

                                {{region.nombre}}

                            </mat-option>

                        </mat-select>

                    </div>

                    <div class = "col-lg-2"> </div>

                </div> <br/>
                <div class = "row">

                    <div class = "col-lg-2"> <h3> ID Solicitud: </h3> </div>

                    <div class = "col-lg-3">

                        <input [(ngModel)] = "buscador.idSolicitud" class = "form-control" type = "number"  pattern = "[0-9]" />

                    </div>

                    <div class = "col-lg-2" > <h3> Estados: </h3> </div>

                        <div class = "col-lg-3" >

                            <mat-select [(ngModel)] = "buscador.estadoselect"  multiple  >

                                <mat-option *ngFor = "let esta of estado" value = "{{esta}}">

                                    {{esta}}

                                </mat-option>

                            </mat-select>

                        </div>

                    <div class = "col-lg-2"> </div>

                </div> <br/>


                <div class = "row">

                    <div class = "col-lg-2"> <h3> Fecha Inicio: </h3> </div>

                    <div class = "col-lg-3">

                        <input name = "fechaInicio" class = "form-control" type = "date" #fechaInicio = "ngModel"
                        [(ngModel)] = "buscador.fechaInicio" placeholder = "Ingrese la fecha Inicio" />

                    </div>

                    <div class = "col-lg-2"> <h3> Fecha Fin: </h3> </div>

                    <div class = "col-lg-3">

                        <input name = "fechaFin" class = "form-control" type = "date" #fechaFin = "ngModel"
                        [(ngModel)] = "buscador.fechaFin" placeholder = "Ingrese la fecha Fin" />

                    </div>

                    <div class = "col-lg-2"> <button class = "btn btn-info" (click) = "buscar()">

                        <i class = "fa fa-search"></i> Buscar </button>

                    </div>

                </div>  <br/>

                <div class = "row">
                    <div class = "col-lg-2" > <h3> Producto: </h3> </div>

                        <div class = "col-lg-3" >

                            <mat-select [(ngModel)] = "buscador.tipoProductoselect"  multiple  >
                                
                                <mat-option *ngFor = "let esta of tipoProducto"  value = "{{esta}}">

                                    {{esta}}

                                </mat-option>

                            </mat-select>

                        </div>

                    <div class = "col-lg-2"> <h3></h3> </div>

                    <div class = "col-lg-3"> </div>

                    <div class = "col-lg-2"> </div>

                </div> <hr/> <br/>





            </div>

            <div class = "row" *ngIf = "tipoPostulacion == 'Disponibles'">

                <div class = "col-lg-2">
                    <h3> <mat-checkbox color = "primary" [checked] = "allComplete" [indeterminate] = "someComplete()"
                    (change) = "setAll($event.checked)"> Seleccionar Todo </mat-checkbox> </h3>
                </div>
                <div *ngIf = "this.rol != 'ROLE_EJECUTIVO_CAIP'"> 
                    <div class = "col-lg-2"> <button mat-button class = "mat-raised-button btn-warning"
                    (click) = "asignarSeleccionados()">

                            <i class = "fa fa-pen"></i> Asignar Seleccionados </button>
                    </div>
                </div>
                <div class = "col-lg-7"> </div>

            </div> <br/>

            <div class = "table-responsive">

                <table class = "table">

                    <thead style = "background-color: #0f69b4;color:white;">

                        <tr>
                            <th *ngIf = "tipoPostulacion == 'Disponibles'"> </th>

                            <th> N° </th>
                            <th> Rut Afiliado </th>
                            <th> Nombre Afiliado </th>
                            <th> Rut Beneficiario </th>
                            <th> Nombre Beneficiario </th>
                            <th> Fecha Ingreso </th>
                            <th> Fecha de Modificación </th>
                            <th> Producto </th>
                            <th> Tipo de Producto </th>
                            <th> Región </th>
                            <th> Ejecutivo </th>
                            <th> Estado </th>
                            <th>  </th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr [class] = "i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor = "let postulacion of postulaciones | paginate: config; let i = index">

                            <td *ngIf = "tipoPostulacion == 'Disponibles' &&
                            ( postulacion.estado == 'INGRESADA'
                            || (this.rol == 'ROLE_ADMINISTRADOR' && tipoPostulacion == 'Disponibles' && postulacion.estado != 'PAGADA')
                            || (postulacion.estado == 'EN VALIDACION' && tipoPostulacion == 'Disponibles')
                            || (postulacion.estado == 'RECHAZADA' && tipoPostulacion == 'Disponibles')
                            )
                            ">
                                <mat-checkbox [(ngModel)] = "postulacion.seleccionado" color = "primary"
                                (ngModelChange) = "updateAllComplete()"> </mat-checkbox>
                            </td>

                            <td *ngIf = "
                            this.rol != 'ROLE_ADMINISTRADOR'
                            && tipoPostulacion == 'Disponibles' && (
                             postulacion.estado == 'PAGADA'
                            || postulacion.estado == 'APROBADA'
                              || postulacion.estado == 'ANULADA'
                            || (postulacion.estado == 'DISPONIBLE PARA PAGO' && this.rol != 'ROLE_ADMINISTRADOR' && tipoPostulacion == 'Disponibles')
                            )    "></td>
                            
                            <td> <a (click) = "openEditDialog(postulacion.posId, postulacion.producto, false,false,postulacion.tipoBeca)"
                            style = "cursor:pointer; text-decoration: underline;"> {{postulacion.posId}} </a> </td>

                            <td> <a (click) = "detalleBeneficiario(postulacion.rutAfiliado)" style = "cursor:pointer; text-decoration: underline;"> {{postulacion.rutAfiliado}} </a> </td>

                            <td> {{postulacion.nombreAfiliado}} </td>

                            <td> {{postulacion.rutPostulante}} </td>

                            <td> {{postulacion.nombrePostulante}} </td>

                            <td> {{postulacion.fechaIngreso}} </td>

                            <td> {{postulacion.fechaModificacion}} </td>

                            <td> {{postulacion.producto}} </td>

                            <td> {{postulacion.tipoBeca}} </td>

                            <td> {{postulacion.nombreRegion}} </td>

                            <td> {{postulacion.usuarioEjecutivo}} </td>

                            <!--<td> {{postulacion.estado}} </td> -->
                            
                            <td style="text-align: center;" *ngIf="postulacion.estado == 'RECHAZADA'"> <a (click)="detalleRechazoBeneficiario(postulacion.posId)" style="cursor:pointer; text-decoration: underline;">{{postulacion.estado}} </a></td>
                            <td style="text-align: center;" *ngIf="postulacion.estado == 'PAGADA'"> <a (click)="detalleSolicitudPagada(postulacion.posId)" style="cursor:pointer; text-decoration: underline;">{{postulacion.estado}} </a></td>
                            <td style="text-align: center;" *ngIf="postulacion.estado != 'RECHAZADA' && postulacion.estado != 'PAGADA'"> {{postulacion.estado}}</td>

                            <td>
                                <button *ngIf = "tipoPostulacion == 'Asignadas' && postulacion.estado == 'EN VALIDACION' " class = "btn btn-success"
                                (click) = "openEditDialog(postulacion.posId, postulacion.producto, true,false,postulacion.tipoBeca)" style = "width: 120px">

                                    <i class = "fa fa-pen"> </i>Gestionar

                                </button>
                                <button *ngIf = "tipoPostulacion == 'Asignadas' && postulacion.estado != 'EN VALIDACION'" class = "btn btn-warning"
                                (click) = "openEditDialog(postulacion.posId, postulacion.producto, true, postulacion.estado == 'DISPONIBLE PARA PAGO',postulacion.tipoBeca )" style = "width: 120px">

                                    <i class = "fa fa-pen"> </i> Revisar

                                </button>
                              
                                                                                                                           
                                <div *ngIf = "(this.rol != 'ROLE_EJECUTIVO_CAIP'  && this.rol != 'ROLE_CONTABILIDAD' && this.rol != 'ROLE_ENCARGADO_CONTABILIDAD') && !((postulacion.tipoBeca == 'CATASTROFE' || postulacion.tipoBeca == 'FALLECIMIENTO') &&  (rol == 'ROLE_ENCARGADO_NACIONAL' || rol == 'ROLE_EJECUTIVO'))">
                                    <button *ngIf = "tipoPostulacion == 'Disponibles' && postulacion.estado != 'PAGADA' && postulacion.estado != 'ANULADA'
                                    && ((postulacion.estado == 'INGRESADA'  && tipoPostulacion == 'Disponibles' && (rol == 'ROLE_ADMINISTRADOR' || rol == 'ROLE_COORDINADOR' || rol == 'ROLE_ENCARGADO_REGIONAL' || rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE' || rol == 'ROLE_EJECUTIVO' || rol == 'ROLE_ENCARGADO_NACIONAL' || rol == 'ROLE_ASISTENTE_SOCIAL'))
                                    || (this.rol == 'ROLE_ADMINISTRADOR' && tipoPostulacion == 'Disponibles' && postulacion.estado != 'PAGADA')
                                    || (postulacion.estado == 'EN VALIDACION' && tipoPostulacion == 'Disponibles' &&  (rol == 'ROLE_ADMINISTRADOR' || rol == 'ROLE_COORDINADOR' || rol == 'ROLE_ENCARGADO_REGIONAL'  || rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE' || rol == 'ROLE_ASISTENTE_SOCIAL' || rol == 'ROLE_ENCARGADO_NACIONAL' || rol == 'ROLE_EJECUTIVO') && !(postulacion.tipoBeca == 'CATASTROFE' || postulacion.tipoBeca == 'FALLECIMIENTO'))
                                    || (postulacion.estado == 'EN VALIDACION' && tipoPostulacion == 'Disponibles' &&  (rol == 'ROLE_ADMINISTRADOR' || rol == 'ROLE_ENCARGADO_REGIONAL'  || rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE' || rol == 'ROLE_ASISTENTE_SOCIAL' || rol == 'ROLE_ENCARGADO_NACIONAL' || rol == 'ROLE_COORDINADOR' ) && (postulacion.tipoBeca == 'CATASTROFE' || postulacion.tipoBeca == 'FALLECIMIENTO'))
                                    || (postulacion.estado == 'RECHAZADA' && tipoPostulacion == 'Disponibles' && this.rol == 'ROLE_ADMINISTRADOR'))
                                    && (idUsuario!=postulacion.posIdUsuAsignado && tipoPostulacion == 'Disponibles')
                                    ;else noAsigna

                                    "
                                    class = "btn btn-warning"  style = "width: 120px" (click) = "asignaPostulacion(postulacion.posId)">

                                        <i class = "fa fa-pen"> </i> Asignar

                                    </button>
                                </div>
                                <ng-template #noAsigna>
                                  <button *ngIf = "tipoPostulacion == 'Disponibles'"
                                   class = "btn btn-secondary" style = "width: 120px" disabled>
                                   Sin acciones
                                  </button>
                                </ng-template>

                            </td>

                        </tr>

                    </tbody>

                </table> <br/>

                <pagination-controls style = "text-align: center" previousLabel = "Anterior" nextLabel = "Siguiente"
                (pageChange) = "pageChanged($event)" autoHide = "true"> </pagination-controls>

            </div>

        </div>

        <div class = "container" style = "height:100px"> </div>

    </div>

</div>
